import axios from 'axios';
const api = axios.create({
  baseURL: 'https://master.jasaindonesiaperdana.com/api', 
});
const imageBaseURL = 'https://master.jasaindonesiaperdana.com/img/bukti/';
const imgProsesBaseURL = 'https://master.jasaindonesiaperdana.com/img/proses/';
const imageProfil = 'https://master.jasaindonesiaperdana.com/img/profil/';
const fileBaseURL = 'https://master.jasaindonesiaperdana.com/documents/';
const prosesBaseURL = 'https://master.jasaindonesiaperdana.com/prosesdokumen/';

// Get userId from localStorage
const userId = localStorage.getItem('userId');
const profilx = JSON.parse(localStorage.getItem('user'));

if (userId) {
  api.defaults.headers.common['User-Id'] = userId;
}

// Function to handle login
export const loginPost = async (email, password) => {
  try {
    const response = await api.post('/login', { email, password });
    return response.data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

// Function to handle logout
export const logoutPost = async () => {
  try {
    const token = localStorage.getItem('token'); // Get the token from localStorage
    const response = await api.post('/logout', {}, {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the request header
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error logging out:', error);
    throw error;
  }
};
export const getProfileData = async () => {
  try {
    const response = await api.get('/getprofil/'+userId);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const saveProfileData = async (formData) => {
  try {
    const response = await api.post('/updateprofil', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};

export const listSchedule = async () => {
  try {
    const response = await api.get('/listschedule/'+userId);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const listHistory = async () => {
  try {
    const response = await api.get('/listshistory/'+userId);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const listProses = async () => {
  try {
    const response = await api.get('/getproses/'+userId);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const listDokumen = async () => {
  try {
    const response = await api.get('/listdokumen/'+userId);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const listPerusahaan = async () => {
  try {
    const response = await api.get('/listperusahaan');
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const submitRequestService = async (formData) => {
  try {
    const response = await api.post('/submitservice', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};
export const submitRequest= async (formData) => {
  try {
    const response = await api.post('/generalrequest', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};

export const codeReset = async (formData) => {
  try {
    const response = await api.post('/reset-code', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};

export const validateResetCode = async (formData) => {
  try {
    const response = await api.post('/password-validate', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};
export const resetPassword = async (formData) => {
  try {
    const response = await api.post('/reset-password', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting request service:', error);
    throw error;
  }
};


// You can also set a default Authorization header if the token is available
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export { api, imageBaseURL, fileBaseURL, userId, imageProfil,profilx,imgProsesBaseURL, prosesBaseURL};
